import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import Dropdown from './Dropdown';
import Sort from './Sort';

function Category ({ sectionCode, categories, categoryCode, sorts, sortCode, onChange, pageChange }) {
  const [currentCategoryCode, setCurrentCategoryCode] = useState(categoryCode || (Array.isArray(categories) && categories.length > 0 ? categories[0]?.code : ''));
  const [currentSortCode, setCurrentSortCode] = useState(sortCode || (Array.isArray(sorts) && sorts.length > 0 ? sorts[0]?.code : ''));

  useEffect(() => {
    if (typeof onChange === 'function') {
      onChange({ categoryCode: currentCategoryCode, sortCode: currentSortCode });
    }
  }, [currentCategoryCode, currentSortCode]);

  return (
    <div className='category_list_w'>
      {(Array.isArray(categories) && categories.length > 0) && (
        <Dropdown
          data={categories}
          sectionCode={sectionCode}
          categoryCode={categoryCode}
          onChange={(categoryCode) => {
            setCurrentCategoryCode(categoryCode.code);
          }}
        />
      )}
      {(Array.isArray(sorts) && sorts.length > 0) && (
        <Sort
          sectionCode={sectionCode}
          categoryCode={categoryCode}
          sortCode={currentSortCode}
          pageChange={pageChange}
          sorts={sorts}
          onChange={(sortCode) => {
            setCurrentSortCode(sortCode);
          }}
        />
      )}
    </div>
  );
}

export default Category;
